import { Reference } from '@approvalmax/types';

import { domain } from '../../../../../../modules/data';
import { discountTypeReference } from './QBooksTaxSwitcherLegacy.constants';

export const findDiscountType = (id: keyof typeof domain.QBooksDiscountType): Reference | null =>
    discountTypeReference.find((discountType) => discountType.id === id) || null;
